import { Role } from "@/core/components/auth/auth.types";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { LoadingList } from "@/core/components/LoadingList";
import { addOnsQueryOptions } from "@/core/components/sites/site/rooms/add-ons/addOnsQueryOptions";
import { redirect } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const addOnsSearchSchema = z.object({
	page: z.number().catch(1),
	pageSize: z.number().catch(10),
	search: z.string().catch(""),
	sortBy: z.enum(["title", "price", "rates", "code"]).catch("title"),
	orderBy: z.enum(["asc", "desc"]).catch("desc"),
});

export const Route = createFileRoute(
	"/_layout/dashboard/sites/$siteId/rooms/add-ons/",
)({
	validateSearch: (search) => addOnsSearchSchema.parse(search),
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({
				to: "/",
			});
		}
		if (
			auth.user?.role === Role["Front-Desk"] ||
			auth.user?.role === Role["Blogger"]
		) {
			throw redirect({
				to: "/dashboard",
			});
		}
	},
	loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		queryClient.ensureQueryData(addOnsQueryOptions(siteId, auth.token!));
	},
	pendingComponent: LoadingList,
	errorComponent: ErrorComponent,
});
